import {BaitCheckerInventory} from 'models/inventory.interface';

export const initialState: {data: BaitCheckerInventory | null} = {
  data: null,
};
